import React from 'react'
import moment from 'moment'

// utils
import { getJobDayStatus } from './JobDayDetailHeader.utils'
import { createUserGroupList } from '../../../../shared/privileges/userGroups'

// query
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS } from '../../../../graphql/jobDay/jobDay.queries'

// components
import SubHeading from '../../../../components/text/SubHeading/SubHeading.component'
import ActionButton from '../../../../components/buttons/ActionButton/ActionButton.component'

// mui
import { Grid, Container, Typography } from '@mui/material'

export default function JobDayDetailHeader({ id, onFinishClick, onApproveClick, onMarkPaidClick, onEditClick, onGenerateClick, usersGroups }) {

    const groups = createUserGroupList(usersGroups)

    const { data } = useQuery(GET_JOB_DAY_WITH_NAME_DATE_AND_STATUS, {
        variables: { id }
    })

    let jobDay = {}
    let actions = null

    // let hasAdminAccess = false
    // usersGroups.forEach(group => {
    //     if(group.name == "Admin") {
    //         hasAdminAccess = true
    //     }
    // })

    let status = "paid"

    if(data && data.jobDay) {
        jobDay = {...data.jobDay}
        status = getJobDayStatus(data.jobDay.crewMemberAssignments)

        switch(status) {

            case 'finish':
                if(!groups.includes("ScheduleReadOnly")){
                    actions = <ActionButton label="Edit Tickets" color="secondary" onClick={onFinishClick} />
                }
                
                break
            case 'preliminary':
                if(groups.includes("Admin")){
                    actions = (<>
                        <ActionButton label="Edit Tickets" color="secondary" onClick={onFinishClick} sx={{ marginRight: 2}} />
                        <ActionButton label="Approve - Preliminary" color="secondary" onClick={() => onApproveClick('preliminary')} />
                        </>)
                } else if(groups.includes("ForemanWithLimitedAdminAccess")) {
                    actions = (<ActionButton label="Edit Tickets" color="secondary" onClick={onFinishClick} sx={{ marginRight: 2}} />)
                }
                
                break

            case 'final':
                if(groups.includes("Admin")){
                    actions = (<ActionButton label="Approve - Final" color="secondary" onClick={() => onApproveClick('final')} />)
                }
                break

            case 'payment':
                if(groups.includes("Admin")){
                    actions = (<ActionButton label="Mark as Paid" color="secondary" onClick={onMarkPaidClick} />)
                }
                break
            
            default:
                break
        }
    }

    return (<React.Fragment>

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><Typography variant="h2">{data ? moment(jobDay.date).format("M/D/YYYY") : ''}</Typography></Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item></Grid>

            </Grid>
        </Container>

        <Container maxWidth sx={{ marginBottom: 4 }} disableGutters>

            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}>{data ? <SubHeading text={jobDay.job.name} /> : ''}</Grid>
                <Grid container item xs={6} justifyContent='flex-end' spacing={2}>
                    {
                        groups.includes("Admin") && <Grid item><ActionButton label="Generate PDF" color="secondary" onClick={onGenerateClick} /></Grid>
                    }
                    
                    <Grid item>{actions}</Grid>
                    { status !== "paid" && !groups.includes("ScheduleReadOnly") && <Grid item><ActionButton label="Edit" onClick={onEditClick} /></Grid> }
                </Grid>
            </Grid>
        </Container>
    </React.Fragment>)
}